import i18next from 'i18next';
import { initReactI18next, Trans as _Trans } from 'react-i18next';

import request from './request';

const { hashKey, extractUrl, LanguageCollection, Languages, env } = require('./common');
const manifest = env === 'dev' ? require('./manifest') : require('./manifest.prod');
const { lngs } = require('./constant');
// 获取当前系统的语种数对象
const LANGS = Object.values(lngs); // 遍历出对应语种
let $lang = 'en'; // 系统当前语种

/**
 * 多语言初始化
 */
export const initI18nData = ({ ns, resources, lang } = {}) => {
  $lang = lang; // 客户端下设置下当前语种
  return i18next.use(initReactI18next).init({
    resources,
    lng: lang,
    fallbackLng: 'en',
    keySeparator: false,
    debug: false,
    ns,
    defaultNS: ns,
    react: {
      hashTransKey: hashKey,
    },
  });
};

/**
 * 获取cms对应routeId对应的翻译文件
 * @param {object} params
 * @returns {object} cms返回的翻译数据
 */
export async function getI18nData(params) {
  const { ns, context, lang } = params;
  let _lang = '';
  if (lang) {
    // 通过传参获取语种信息
    _lang = LANGS.includes(lang) ? lang : 'en'; // 如果传入是合法语种则取其参数，作为语种，否则默认为英文
  } else {
    console.warn('[deprecated] 多语言库该传参处理方式即将废弃'); // log
    // TODO: deprecated
    // 通过 cookie 获取语种信息
    const cookieStr = context?.req?.headers?.cookie; // 从请求中获取cookie
    if (cookieStr) {
      const cookieArr = cookieStr.match(/[^\s]*(;|[^\s]$)/gi).map((item) => item.split(/=/g));
      const cookieObj = {};
      cookieArr.forEach((item) => {
        cookieObj[item[0]] = item[1].includes(';') ? item[1].split(/;/)[0] : item[1];
      });
      _lang = cookieObj.intl_language || cookieObj.language || 'en'; // 默认为英语
    } else {
      _lang = 'en'; // 当 cookie 不存在时，默认为 en
    }
  }
  let langPkgPri = {
    [_lang]: {},
  };
  $lang = _lang; // 在服务端设置下当前语种
  if (Array.isArray(ns)) {
    // 如果是查询多个模块的数据
    const routeArr = ns.map((item) => ({ id: manifest[item]?.routeId, ns: item }));
    for (const item of routeArr) {
      if (Number.isInteger(item.id)) {
        const i18nData = await request(item.id, _lang);
        langPkgPri = {
          [_lang]: {
            ...langPkgPri[_lang],
            [item.ns]: JSON.parse(i18nData),
          },
        };
      }
    }
  } else {
    // 如果查询的单个模块
    const routeId = manifest[ns]?.routeId;
    const i18nData = await request(routeId, _lang);
    langPkgPri = {
      [_lang]: {
        ...langPkgPri[_lang],
        [ns]: JSON.parse(i18nData),
      },
    };
  }
  return {
    resources: langPkgPri,
    ns,
    lang: _lang,
  };
}

/**
 *	词条相关
 */
export const t = (sentence, options) => {
  const key = hashKey(sentence);
  const text = i18next.t(key, { ...(options || {}), defaultValue: sentence });
  return text;
};

/**
 *	替换成当前语言的访问链接，此处忽略了runtime的逻辑，后续要考虑是否要调整
 */
export const l = (srcUrl, language = 'en') => {
  const { protocal, host, language: _language, path } = extractUrl(srcUrl);

  // language = language || runtime.language;

  if (_language === language) {
    return srcUrl;
  }
  const pathbase = LanguageCollection.entities[language].path;
  return `${protocal}${host}${pathbase}${path}` || '/';
};

export const L = Languages;

/**
 * 链接相关
 */
export const removeLngPath = (srcUrl) => {
  const { protocal, host, path } = extractUrl(srcUrl);
  return `${protocal}${host}${path}`;
};

export { LanguageCollection, Languages };

export const runtime = {
  get language() {
    return $lang;
  },
  get languagePath() {
    const { language } = this;
    return LanguageCollection.entities[language].path;
  },
};

export const Trans = _Trans;
